import { render } from "./TheFirst.vue?vue&type=template&id=7268350b&scoped=true&lang=pug&bindings={}"
import script from "./TheFirst.vue?vue&type=script&lang=js"
export * from "./TheFirst.vue?vue&type=script&lang=js"

import "./TheFirst.vue?vue&type=style&index=0&id=7268350b&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-7268350b"

export default script